const captionCls = "_uihc1vshmxt";
const titleCls = "_uiht12etk5a";
const spanCls = "_uihsd0yj1t";

export { captionCls, spanCls, titleCls };
import "./caption.style.linaria.module.css";
//# sourceMappingURL=caption.style.js.map
